var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnFinalEndingBadge = function SvgIcnFinalEndingBadge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1984_147626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0H32V25.5682C32 26.2633 31.3084 26.7464 30.6557 26.5071L17.3443 21.6262C17.122 21.5447 16.878 21.5447 16.6557 21.6262L3.34426 26.5071C2.69164 26.7464 2 26.2633 2 25.5682V0Z",
    fill: "#753BBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42842 9.104H10.4744C10.2984 10.028 9.28642 10.798 8.10942 11.062L8.74742 12.052C9.74842 11.799 10.8044 11.018 11.1784 10.193C11.5854 10.897 12.6414 11.612 13.4664 11.788C13.6644 11.447 13.8624 11.095 14.0604 10.765C13.1034 10.644 12.0474 9.94 11.8384 9.104H13.7744V8.092H8.42842V9.104ZM15.9964 6.068H14.6984V15.869H15.9964V6.068ZM14.1924 12.8C13.4884 12.888 12.6744 12.965 11.7944 12.998V11.447H10.4964V13.053C9.63842 13.075 8.73642 13.075 7.83442 13.075L8.02142 14.12C9.85842 14.12 12.5094 14.021 14.2914 13.779L14.1924 12.8ZM9.68242 7.553H12.6084V6.541H9.68242V7.553ZM25.173 14.043C25.173 12.932 23.93 12.239 21.752 12.239C19.596 12.239 18.342 12.932 18.342 14.043C18.342 15.176 19.596 15.869 21.763 15.869C23.93 15.869 25.173 15.176 25.173 14.043ZM25.767 9.126C24.502 9.082 22.995 8.422 22.566 7.454H25.316V6.442H18.221V7.454H20.982C20.597 8.411 19.255 9.071 17.77 9.148L18.298 10.149C19.849 10.028 21.279 9.28 21.763 8.279C22.313 9.258 23.842 10.017 25.217 10.138L25.767 9.126ZM26.185 11.799V10.765H22.379V9.533H21.092V10.765H17.33V11.799H26.185ZM23.853 14.054C23.853 14.549 23.028 14.857 21.752 14.857C20.487 14.857 19.673 14.549 19.673 14.054C19.673 13.559 20.487 13.251 21.752 13.251C23.028 13.251 23.853 13.559 23.853 14.054Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1984_147626",
    x: 0,
    y: -1,
    width: 34,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1984_147626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1984_147626",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnFinalEndingBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_final_ending_badge.bc8d3e37.svg";
export { ForwardRef as ReactComponent };